var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.0001H6.75L17.81 9.94006L14.06 6.19006L3 17.2501V21.0001ZM5 18.0801L14.06 9.02006L14.98 9.94006L5.92 19.0001H5V18.0801Z",
    fill: "#085B3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3699 3.29006C17.9799 2.90006 17.3499 2.90006 16.9599 3.29006L15.1299 5.12006L18.8799 8.87006L20.7099 7.04006C21.0999 6.65006 21.0999 6.02006 20.7099 5.63006L18.3699 3.29006Z",
    fill: "#085B3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.4093c1b090c68f6f4270a66bb51234c4.svg";
export { ForwardRef as ReactComponent };